module.exports = __webpack_public_path__ + "img/location_place.34f7e0e3.svg";